import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, Card } from "@/pages/AppLayout";
import { SUB_STATUS } from "@/pages/Plan";

const REASONS = {
  mensaje_ia: "Operación de agentes IA", compra_paquete: "Compra de paquete", suscripcion: "Suscripción",
  renovacion_suscripcion: "Renovación de suscripción", ajuste_admin: "Ajuste del administrador", despliegue: "Publicación", cupon: "Cupón",
};

const Metric = ({ label, value, testId }) => (
  <Card><p className="text-xs uppercase tracking-widest text-slate-500">{label}</p><p className="font-display text-2xl font-bold text-white mt-1" data-testid={testId}>{value}</p></Card>
);

export default function Usage() {
  const [rows, setRows] = useState(null);
  const [sum, setSum] = useState(null);
  useEffect(() => { api.get("/billing/usage").then((r) => setRows(r.data)); api.get("/billing/summary").then((r) => setSum(r.data)); }, []);

  return (
    <div data-testid="usage-page">
      <PageHeader eyebrow="Consumo" title="Historial de consumo" subtitle="Movimientos de créditos con el detalle de cada operación: estimado, real y modelo de IA."
        action={<div className="flex gap-2"><Link to="/app/creditos" className="px-4 py-2 rounded-full bg-blue-500 hover:bg-blue-400 text-white text-sm" data-testid="usage-buy-link">Comprar créditos</Link><Link to="/app/plan" className="px-4 py-2 rounded-full border border-[#222B40] text-slate-200 text-sm" data-testid="usage-plan-link">Mejorar plan</Link></div>} />
      {sum && (
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
          <Metric label="Disponibles" value={sum.credits} testId="usage-available" />
          <Metric label="Usados (total)" value={sum.used_total} testId="usage-spent" />
          <Metric label="Usados este mes" value={`${sum.used_this_month}${sum.monthly_limit ? ` / ${sum.monthly_limit}` : ""}`} testId="usage-month" />
          <Metric label="Plan" value={sum.plan ? sum.plan.name.replace("Plan ", "") : "Sin plan"} testId="usage-plan" />
          <Metric label="Renovación" value={sum.renewal_date ? fmtDate(sum.renewal_date).split(",")[0] : "—"} testId="usage-renewal" />
        </div>
      )}
      {sum?.subscription && <p className="text-xs text-slate-500 -mt-4 mb-8">Estado de la suscripción: {SUB_STATUS[sum.subscription.status]}</p>}
      <Card className="p-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid="usage-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-[#222B40]">
            <th className="p-4">Fecha</th><th className="p-4">Concepto</th><th className="p-4">Detalle</th><th className="p-4 text-right">Créditos</th>
          </tr></thead>
          <tbody>
            {rows?.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-slate-500" data-testid="usage-empty">Sin movimientos todavía.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.id} className="border-b border-[#222B40]/60 last:border-0">
                <td className="p-4 text-slate-400 whitespace-nowrap">{fmtDate(r.created_at)}</td>
                <td className="p-4 text-slate-200">{REASONS[r.reason] || r.reason}</td>
                <td className="p-4 text-slate-400 font-mono text-xs">
                  {r.meta?.project_name ? `${r.meta.project_name}${r.meta.model ? ` · ${r.meta.model}` : ""}${r.meta.version ? ` · v${r.meta.version}` : ""}${r.meta.estimated ? ` · est. ${r.meta.estimated} / real ${r.meta.real}` : ""}` : r.meta?.note || r.meta?.plan || r.meta?.code || "—"}
                </td>
                <td className={`p-4 text-right font-mono ${r.amount < 0 ? "text-red-300" : "text-emerald-300"}`}>{r.amount > 0 ? `+${r.amount}` : r.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
